/* global mixpanel */

import {select} from 'redux-saga/effects'

export const getBusinessId = state => state.moka.user.business.id
export const getOutletId = state => state.moka.user.outlet_id[0]

export function * tableGroupStart ({totalTableGroup}) {
  let outletId = yield select(getOutletId)
  mixpanel.track('Table Group Start', {
    'Current Selected Outlet': outletId,
    'Total Table Group': totalTableGroup
  })
}

export function createTableGroupCancel () {
  mixpanel.track('Create Table Group Cancel', {
  })
}

export function createTableGroupSuccess (data) {
  const {name, active} = data
  mixpanel.track('Create Table Group Success', {
    'Table Group Name': name,
    'Table Group Status': active
  })
}

export function tableGroupUpdateCancel () {
  mixpanel.track('Table Group Update Cancel', {
  })
}

export function tableGroupUpdate (data) {
  const {oldName, newName, oldStatus, newStatus, tableCount} = data
  mixpanel.track('Table Group Updated', {
    'Old Name': oldName,
    'New Name': newName,
    'Old Table Group Status': oldStatus,
    'New Table Group Status': newStatus,
    'Table Count': tableCount
  })
}

export function createTableGroupDeleted (data) {
  const {deletedName, deletedTableCount} = data
  mixpanel.track('Table Group Deleted', {
    'Table Group Name': deletedName,
    'Table Count': deletedTableCount
  })
}

export function createTableGroupDeleteCancel () {
  mixpanel.track('Table Group Delete Cancel', {
  })
}

export function tableGroupDuplicateConfirm (data) {
  const {name, active, numberOfTables} = data
  mixpanel.track('Table Group Duplicated', {
    'Table Group Name': name,
    '(Duplicate Source) Table Status': active,
    'Table Count': numberOfTables
  })
}

export function tableGroupDuplicateCancel () {
  mixpanel.track('Table Group Duplicate Cancel', {
  })
}

export function tableGroupEnterMapLayout () {
  mixpanel.track('Table Group Enter Map Layout', {
  })
}

export function * tableMapStart () {
  let outletId = yield select(getOutletId)
  mixpanel.track('Table Map Start', {
    'Current Selected Outlet': outletId
  })
}

export function addTableCancel () {
  mixpanel.track('Add Table Cancel', { })
}

export function * addTableSuccess ({name, maxPax, shape, groupName}) {
  let outletId = yield select(getOutletId)
  mixpanel.track('Add Table Success', {
    'Current Selected Outlet': outletId,
    'Table Group Name': groupName,
    'Table Name': name,
    'Table Shape': shape,
    'Num of Table Pax': maxPax
  })
}

export function * editTableCancel (table) {
  let outletId = yield select(getOutletId)
  mixpanel.track('Edit Table Cancel', {
    'Current Selected Outlet': outletId,
    'Table Name': table.name,
    'Table Shape': table.shape,
    'Num of Table Pax': table.maxPax
  })
}

export function * editTableSuccess (table, groupDetail) {
  let outletId = yield select(getOutletId)
  mixpanel.track('Edit Table Success', {
    'Current Selected Outlet': outletId,
    'Table Group Name': groupDetail.name,
    'Table Name': table.name,
    'Table Shape': table.shape,
    'Num of Table Pax': table.maxPax
  })
}

export function * deleteTableSuccess (table) {
  let outletId = yield select(getOutletId)
  mixpanel.track('Delete Table Success', {
    'Current Selected Outlet': outletId,
    'Table Name': table.name,
    'Table Shape': table.shape,
    'Num of Table Pax': table.maxPax
  })
}

export function * tableMapSaveChanges (data) {
  const {active, oldTableCount, newTableCount, movement} = data
  mixpanel.track('Table Map Save Changes', {
    'Table Group Status': active,
    'Old Table Count': oldTableCount,
    'New Table Count': newTableCount,
    'Table Movement aside from Add & Delete (Yes/No)': movement
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/tableManagement/index.js